import React from 'react';
import ReactDOM from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import MaskedInput from 'react-text-mask';
import TextInput from '../../Shared/Form/Inputs/TextInput';
import moment from 'moment';
import Validator from '../../Shared/Helpers/Validator';
import Api from '../../Shared/Helpers/Api';


export default class CouponSignUpForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errors: {
            },
            inputData: {
                name: "",
                phone: "",                
                timeStamp: moment(),
                dealerOfferId: 0,
                offerId: 0
            },
            captcha: null
        };

        this.setSignUpFormState = this.setSignUpFormState.bind(this);
        this.setCaptha = this.setCaptha.bind(this);
        this.submitRequest = this.submitRequest.bind(this);
    }

    componentDidMount() {

    }


    // Captcha methods
    onChange(value) { }

    setCaptha(el) {
        let field = 'captcha';
        let value = el;

        this.state[field] = value;

        return this.setState({
            captcha: this.state.captcha
        });
    }

    // Form methods
    setSignUpFormState(e) {
        let field = e.target.name;
        let value = e.target.value;

        this.state.inputData[field] = value;

        return this.setState({
            inputData: this.state.inputData
        });
    }

    submitRequest() {
        //event.preventDefault();

        if (this.isValid()) {
            this.state.inputData.dealerOfferId = this.props.model.dealerOfferId;       
            this.state.inputData.offerId = this.props.model.couponId;  

            let response = Api.sendCouponSignUpForm(this.state.inputData)
                .then((res) => {
                    if (res.status === 200) {
                        console.log("Coupon Sign-Up Form was sent");
                        let couponId = this.props.model.couponId;
                        window.location.href = '/Special-Offers/GetCouponAfterSignUp/' + couponId;
                    }
                    else {
                        console.log("Coupon Sign-Up Form wasn't sent");
                        this.state.errors['form'] = 'An error happened while sending your request!';
                        this.setState({
                            errors: this.state.errors
                        });
                    }
                })
                .catch((res) => {
                    console.log("Coupon Sign-Up Form wasn't sent");
                    this.state.errors['form'] = 'An error happened while sending your request!';
                    this.setState({
                        errors: this.state.errors
                    });
                });
        }
    }

    isValid() {
        let isValid = false;
        this.state.errors = {};
        let form = this.state.inputData;

        if (!Validator.name(this.state.inputData.name)) {
            this.state.errors['name'] = 'Please enter your name';
        }

        if (!Validator.callFormPhone(this.state.inputData.phone)) {
            this.state.errors['phone'] = 'Please enter a valid phone number!';
        }

        if (!this.state.captcha.getValue()) {
            this.state.errors['captcha'] = 'Please check the captcha';
        }

        this.setState({
            errors: this.state.errors
        });
        
        if (!Object.keys(this.state.errors).length) {
            isValid = true;
        }

        return isValid;
    }


    // Render method
    render() {
        let displayError = Object.keys(this.state.errors).length > 0 ? this.state.errors[Object.keys(this.state.errors)[0]] : '';

        return (
            <form className="form-wrapper">
                <h2>Coupon sign-up</h2>
                <fieldset>
                    <p className="b-intro">
                        For a custom coupon just for you, please enter your name and phone number.
                    </p>

                    <p className="validation-errors">
                        {displayError}
                    </p>

                    <TextInput
                        placeholder="Full Name"
                        name="name"
                        onChange={this.setSignUpFormState}
                        isInvalid={this.state.errors['name']}
                    />

                    <MaskedInput
                        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        placeholder="Phone Number"
                        className={this.state.errors['phone'] !== undefined ? "a-input invalid" : "a-input"}
                        onChange={this.setSignUpFormState}
                        name="phone"
                        isInvalid={this.state.errors['phone']}
                    />

                    <input
                        placeholder="Time stamp"
                        name="timeStamp"
                        className="timeStampInput"
                    />

                    <ReCAPTCHA
                        name="captcha"
                        ref={this.setCaptha}
                        className="recaptcha-widget"
                        sitekey="6LcfSkAUAAAAAA-xHDC03d2rghgPjkWMf7Mgd5eU"
                        onChange={this.onChange}
                    />
                </fieldset>

                <button
                    className="apply-btn"
                    type="button"
                    onClick={this.submitRequest}>
                    Submit
                </button>
            </form>
        );
    }
}


let container = document.getElementById('coupon_sign_up_container');

if (container) {
    let model = {
        dealerOfferId: container.dataset.dealerOfferId,
        couponId: container.dataset.couponId,
        dealerId: container.dataset.dealerId
    };

    ReactDOM.render(<CouponSignUpForm  model={model}  />, container);
}


// WEBPACK FOOTER //
// ./Src/Coupons/CouponSignUpForm/CouponSignUpForm.jsx